import type { RouteObject } from 'react-router'

const lazy = (loader: () => Promise<{ default: React.ComponentType }>) => async () => {
  const m = await loader()
  return { Component: m.default }
}

const named =
  <K extends string>(loader: () => Promise<Record<K, React.ComponentType>>, key: K) =>
  async () => {
    const m = await loader()
    return { Component: m[key] }
  }

export const portalRoutes: RouteObject[] = [
  { index: true, lazy: lazy(() => import('./Overview')) },
  { path: 'profile', lazy: lazy(() => import('./Profile')) },
  { path: 'organizations/:id', lazy: lazy(() => import('./OrganizationEdit')) },
  { path: 'applications', lazy: named(() => import('./Applications'), 'PortalApplications') },
  {
    path: 'applications/:id',
    lazy: named(() => import('./Applications'), 'PortalApplicationDetail'),
  },
  { path: 'pay/application/:id', lazy: named(() => import('./Payments'), 'PayApplication') },
  { path: 'payments', lazy: named(() => import('./Payments'), 'PortalPayments') },
  { path: 'payments/:id', lazy: named(() => import('./Payments'), 'PortalPaymentDetail') },
  { path: 'donations', lazy: lazy(() => import('./Donations')) },
  { path: 'statements/:year', lazy: lazy(() => import('./Statement')) },
  { path: 'fundraisers', lazy: named(() => import('./Fundraisers'), 'MyFundraisers') },
  { path: 'fundraisers/new', lazy: named(() => import('./Fundraisers'), 'NewFundraiser') },
  { path: 'volunteering', lazy: lazy(() => import('./Volunteering')) },
  { path: 'orders', lazy: named(() => import('./Orders'), 'PortalOrders') },
  { path: 'orders/:id', lazy: named(() => import('./Orders'), 'PortalOrderDetail') },
  { path: 'sponsorships', lazy: named(() => import('./Sponsorships'), 'PortalSponsorships') },
  {
    path: 'sponsorships/:id',
    lazy: named(() => import('./Sponsorships'), 'PortalSponsorshipDetail'),
  },
  {
    path: 'participation/:id',
    lazy: named(() => import('./Participation'), 'PortalParticipation'),
  },
  { path: 'notifications', lazy: lazy(() => import('./Notifications')) },
  { path: '*', lazy: lazy(() => import('../public/NotFound')) },
]
